import { DEVICE_MANAGEMENT_FEATURE_FLAG } from 'core/service/feature-flag/feature-flag.constants';
import { useGetEnabledFeatureFlags } from 'core/contexts/feature-flags/hooks/use-get-enabled-feature-flags.hook';
import React from 'react';
import { getOnetimeDeviceImport } from '../onetime-device-import.service';
import { OnetimeDeviceImportAPI } from '../onetime-device-import.api';

export const useFetchOnetimeDeviceImport = () => {
    const [data, setData] = React.useState<OnetimeDeviceImportAPI | null>(null);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const enabledFeatureFlags = useGetEnabledFeatureFlags();
    const isDeviceManagementEnabled = enabledFeatureFlags.includes(DEVICE_MANAGEMENT_FEATURE_FLAG);

    const fetchImportStatus = React.useCallback(() => {
        if (!isDeviceManagementEnabled) {
            return;
        }
        setIsLoading(true);
        getOnetimeDeviceImport()
            .then(setData)
            .finally(() => setIsLoading(false));
    }, [isDeviceManagementEnabled]);

    React.useEffect(() => {
        fetchImportStatus();
    }, [fetchImportStatus]);

    return { data, isLoading, refresh: fetchImportStatus };
};
